import { Component, OnInit,ChangeDetectorRef, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddContactComponent } from '../add-contact/add-contact.component';
import { EntityService } from '../../entity.service';
@Component({
  selector: 'app-contacts-events',
  templateUrl: './contacts-events.component.html',
  styleUrls: ['./contacts-events.component.scss']
})
export class ContactsEventsComponent implements OnInit,OnChanges {
  cntctsLst=[];
  enty_ky=0;
  hndlr_nm='';
  @Input() cpmntData;
  @Input() getList:boolean=false;
  loader
  constructor(private _matDialog: MatDialog, private _contactService: EntityService,private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.enty_ky=this.cpmntData.enty_ky;
    this.hndlr_nm=this.cpmntData.hndlr_nm
    this.getContacts(this.enty_ky,this.hndlr_nm);
  }
  ngOnChanges(){
    if(this.getList == true)
    {
      this.getContacts(this.enty_ky,this.hndlr_nm);
    }

  }
  addNewContact(): void {
    const dialogRef = this._matDialog.open(AddContactComponent,{
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky: this.enty_ky
      }
    });

    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getContacts(this.enty_ky,this.hndlr_nm)
      });
  }

  removeContact(Contact) {
    this._contactService.remove_contact(Contact).subscribe((res) => {
      if (res['status'] == 200) {
        this._contactService.openSnackBar("Contact removed successfully.", 'mat-primary');
        this.getContacts(this.enty_ky,this.hndlr_nm);
      }
      else {
        this._contactService.openSnackBar("Something went Wrong! Action denied.", 'amber');
        this.getContacts(this.enty_ky,this.hndlr_nm)
      }
    }, (err) => {
    })
  }
  edtCntct(edtData)
  {
    const dialogRef = this._matDialog.open(AddContactComponent, {
      data: {
        hndlr_nm: this.hndlr_nm,
        enty_ky:this.enty_ky,
        edit_in:1,
        editData:edtData
      }
    });
    dialogRef.afterClosed()
      .subscribe((result) => {
        this.getContacts(this.enty_ky,this.hndlr_nm)
      });
  }

  getContacts(id,hndlr_nm)
  {
    this.loader=true
    this._contactService.getContacts(id,hndlr_nm).subscribe((res) => {
      this.loader=false;
      if(res['status']==200)
      {
        this.cntctsLst=res['data']
        this._changeDetectorRef.markForCheck();
      }
      else
      {
        this._contactService.openSnackBar(res['message'],'mat-warn')
      }
      
    })
  }
}
